import React from "react";
import Select from "react-select";
import useLocationOptions from "../../hook/useLocationOptions";

const LocationSelectComponent = ({
    value,
    onChange,
    label,
    required,
    ...props
}) => {
    const { options } = useLocationOptions();

    const selectedOption = options.find(
        (opt) => opt.value === value?.value
    ) || value || null;

    return (
        <div>
            {label && (
                <label className="form-label">
                    {label}
                    {required && <span className="text-danger"> *</span>}
                </label>
            )}

            <Select
                options={options}
                value={selectedOption}
                onChange={onChange}
                {...props}
            />
        </div>
    );
};

export default LocationSelectComponent;